// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1crwp","col":"styles_col__22zzG","actions":"styles_actions__1gitP","conflict":"styles_conflict__Vw3Yi"};